export const INCUBATOR_PROGRAM_FEE_USD = 5_000;
export const INCUBATOR_PROGRAM_FEE_CENTS = INCUBATOR_PROGRAM_FEE_USD * 100;
export const INCUBATOR_PROGRAM_FEE_LABEL = `$${INCUBATOR_PROGRAM_FEE_USD.toLocaleString()}`;

export const INCUBATOR_PRODUCT_CREDITS_USD = 15_000;
export const INCUBATOR_PRODUCT_CREDITS_LABEL = `$${INCUBATOR_PRODUCT_CREDITS_USD.toLocaleString()}`;

export const INCUBATOR_DURATION_LABEL = '4–6 weeks';

/** F6S AI Incubator apply page — primary application intake. */
export const INCUBATOR_F6S_URL = 'https://www.f6s.com/aiincubator/';

export const INCUBATOR_CHECKOUT_KEY = 'incubator' as const;

export const INCUBATOR_INCLUDES = [
  {
    title: 'Platform build support',
    text: `Hands-on help shipping your product — scoped ${INCUBATOR_DURATION_LABEL} studio sprint with SELF Labs engineers and founders.`,
  },
  {
    title: 'Product credits',
    text: `Up to ${INCUBATOR_PRODUCT_CREDITS_LABEL} in credits toward SELF Labs products — Living Website, Role Model AI, Resonatia, and more.`,
  },
  {
    title: 'Studio mentorship',
    text: 'Direct access to SELF Labs for product, AI architecture, GTM, and living-website strategy.',
  },
  {
    title: 'Investment consideration',
    text: 'Selected companies may be considered for investment from SELF Labs. Consideration is discretionary — not guaranteed by the program fee.',
  },
] as const;

export const INCUBATOR_WHO_FOR = [
  'Early AI and platform startups ready to ship',
  'Founders who want build help plus SELF Labs stack credits',
  'Teams seeking a studio relationship — not just a freelance quote',
  'Companies that may later seek investment from SELF Labs',
] as const;

export const INCUBATOR_PROCESS = [
  {
    step: '1',
    title: 'Apply',
    text: 'Submit via F6S or contact Milan with your company, stage, and what you are building.',
  },
  {
    step: '2',
    title: 'Selection',
    text: 'We review fit for the cohort — product, team, and how SELF Labs can help you ship.',
  },
  {
    step: '3',
    title: 'Program fee',
    text: `Accepted companies receive a cohort access code, then pay the ${INCUBATOR_PROGRAM_FEE_LABEL} program fee to reserve a seat.`,
  },
  {
    step: '4',
    title: 'Build',
    text: `Enter the ${INCUBATOR_DURATION_LABEL} sprint — platform support, credits, mentorship, and investment consideration.`,
  },
] as const;

export const INCUBATOR_FAQS = [
  {
    q: 'Is investment guaranteed if I pay $5,000?',
    a: 'No. The program fee covers build support, product credits, and mentorship. Investment into selected companies is discretionary and not promised by payment.',
  },
  {
    q: 'How is this different from Build with SELF Labs?',
    a: 'Build is custom scoped software with an itemized quote. The Incubator is a fixed-fee cohort program with credits, mentorship, and possible investment consideration.',
  },
  {
    q: 'When do I pay?',
    a: 'If accepted, we send a cohort access code. Enter that code anytime to unlock Stripe checkout for the program fee — even after new applications close for the current window.',
  },
  {
    q: 'When are applications open?',
    a: 'New applications open for two weeks after each seven-week closed period. The live countdown shows the next change. Accepted companies can still pay the program fee with their cohort code while applications are closed.',
  },
  {
    q: 'What is the cohort access code?',
    a: 'Accepted applicants receive a unique cohort code by email. Checkout will not start without a valid code.',
  },
  {
    q: 'What can product credits be used for?',
    a: 'Credits apply toward SELF Labs commercial products such as Living Website, Role Model AI / Concierge, Resonatia, and related offerings — allocated during onboarding.',
  },
] as const;
